import React from "react";
import styled from "styled-components";
import { Button, MenuItem } from "@blueprintjs/core";
import { ItemRenderer, Select } from "@blueprintjs/select";

import { ALLOWED_VISUAL_PATTERN_KEYS } from "@constants";

const PatternSingleSelect = Select.ofType<string>();

const StyledSelector = styled(Button)`
  width: 180px;
  flex-basis: 160px;
  margin-right: 5px;
  text-align: right;
`;

const renderPattern: ItemRenderer<string> = (
  pattern,
  { modifiers, handleClick }
) => {
  if (!modifiers.matchesPredicate) {
    return null;
  }
  return (
    <MenuItem
      active={modifiers.active}
      key={pattern}
      onClick={handleClick}
      text={pattern}
      shouldDismissPopover={false}
    />
  );
};

interface Props {
  onChange: (pattern: ALLOWED_VISUAL_PATTERN_KEYS) => void;
  value: ALLOWED_VISUAL_PATTERN_KEYS;
  disabled: boolean;
}

const typeFromText = (selection: string) => {
  let newType: ALLOWED_VISUAL_PATTERN_KEYS = "pattern";
  switch (selection) {
    case "and is inside":
      newType = "pattern-inside";
      break;
    case "and is not":
      newType = "pattern-not";
      break;
    case "and is not inside":
      newType = "pattern-not-inside";
      break;
    case "and autofix is":
      newType = "pattern-fix";
      break;
    case "and matches regex":
      newType = "pattern-regex";
      break;
  }
  return newType;
};

const textFromType = (
  isFirst: boolean,
  selection: ALLOWED_VISUAL_PATTERN_KEYS
) => {
  if (isFirst && selection !== "pattern-fix") return "code is";
  let newString: string = "or is";
  switch (selection) {
    case "pattern":
      newString = "or is";
      break;
    case "pattern-inside":
      newString = "and is inside";
      break;
    case "pattern-not":
      newString = "and is not";
      break;
    case "pattern-not-inside":
      newString = "and is not inside";
      break;
    case "pattern-fix":
      newString = "and autofix is";
      break;
    case "pattern-regex":
      newString = "and matches regex";
      break;
  }
  return newString;
};

export const PatternSelect: React.FC<Props> = ({
  onChange,
  value,
  disabled,
}) => {
  return (
    <PatternSingleSelect
      items={[
        "code is",
        "or is",
        "and is inside",
        "and is not",
        "and is not inside",
        "and matches regex",
        "and autofix is",
      ]}
      itemRenderer={renderPattern}
      filterable={false}
      className={"selector"}
      disabled={disabled}
      noResults={<MenuItem disabled={true} text="huh?" />}
      onItemSelect={(selected: string) => onChange(typeFromText(selected))}
      popoverProps={{
        minimal: true,
      }}
    >
      <StyledSelector
        icon={disabled ? undefined : "caret-down"}
        disabled={disabled}
      >
        {textFromType(disabled, value)}
      </StyledSelector>
    </PatternSingleSelect>
  );
};
